import { render, staticRenderFns } from "./DataReportsOperator.vue?vue&type=template&id=182fb016"
import script from "./DataReportsOperator.vue?vue&type=script&lang=js"
export * from "./DataReportsOperator.vue?vue&type=script&lang=js"
import style0 from "./DataReportsOperator.vue?vue&type=style&index=0&id=182fb016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports